"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbortFUPModal = void 0;
const native_base_1 = require("native-base");
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const followUpPrescriptionSlice_1 = require("../../../../store/reducers/followUpPrescriptionSlice");
//@ts-ignore
function AbortFUPModal(props) {
    const { navigation, setCurrentPage, showFUPRModal, setShowFUPRModal } = props;
    const dispatch = (0, hooks_1.useAppDispatch)();
    const abortFUP = () => {
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 1,
            },
        };
        setCurrentPage(reducerType);
        dispatch((0, reducers_1.setPrescriptionInfo)(followUpPrescriptionSlice_1.initialState));
        setShowFUPRModal(false);
        navigation.navigate('Dashboard');
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(native_base_1.Center, null,
            react_1.default.createElement(native_base_1.Modal, { isOpen: showFUPRModal, onClose: () => {
                    setShowFUPRModal(false);
                } },
                react_1.default.createElement(native_base_1.Modal.Content, { w: '90%' },
                    react_1.default.createElement(native_base_1.Center, { w: "100%" },
                        react_1.default.createElement(native_base_1.Text, { my: '5', fontSize: "xl", w: "80%", textAlign: "center", color: "#3db384", fontWeight: "bold" }, "Antrag abbrechen"),
                        react_1.default.createElement(native_base_1.Text, { px: '3', mb: '10', textAlign: 'center' }, "M\u00F6chten Sie Ihren Antrag abbrechen und zum Dashboard zur\u00FCckkehren?")),
                    react_1.default.createElement(native_base_1.VStack, { space: 2, justifyContent: "center", alignItems: 'center', pb: '5' },
                        react_1.default.createElement(native_base_1.Button, { w: '60%', backgroundColor: '#3db384', borderRadius: "3xl", _text: { color: '#fff', fontWeight: 'bold' }, onPress: abortFUP }, "Ja, zum Dashboard"),
                        react_1.default.createElement(native_base_1.Button, { w: "40%", backgroundColor: '#FF', borderRadius: "3xl", _text: { color: '#3db384', fontWeight: 'bold', underline: true }, onPress: () => setShowFUPRModal(false) }, "Nein")))))));
}
exports.AbortFUPModal = AbortFUPModal;
